module.exports = __webpack_public_path__ + "static/media/zodiac-scorpio.70a0df27.png";